<h1 class="mb-4">
  <mdb-icon fas icon="cog"></mdb-icon> Mercaderia devuelta
</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Liquidación Recorridos</span>
      <span> /</span>
      <span>Mercaderia devuelta</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row mb-2 filtros-body">
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" formControlName="fechaProceso" name="fechaProceso"
              [placeholder]="'Fecha de proceso'" required></mdb-date-picker>

          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form">
            <mdb-select [options]="optionsRecorrido" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar recorrido" formControlName="listaRecorridos"></mdb-select>
            <label>Nro de recorrido</label>
          </div>
        </div>
        <div class="col" style="max-width: 150px" [ngStyle]="{'display': divStyle}">
          <div class="md-form">
            <span class="value">{{camion_patente}}</span>
            <label for="patente">Patente</label>
          </div>
        </div>
        <div class="col" style="max-width: 200px" [ngStyle]="{'display': divStyle}">
          <div class="md-form">
            <span class="value">{{choferNombre}}</span>
            <label for="chofer">Chofer</label>
          </div>
        </div>

      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>

  </div>



</form>

<!-- Listado -->
<div class="card mb-2 wow" *ngIf="this.processing">
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <div *ngIf="loading" style="margin-left:50%">
      <span>
        <mdb-spinner spinnerColor="blue"></mdb-spinner>
      </span>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaRecorridosDev">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Codigo</th>
            <th scope="col">Detalle</th>
            <th scope="col">Formato</th>
            <th scope="col" class="text-right">Cajas</th>
            <th scope="col" class="text-right">Unidades</th>
          </tr>
        </thead>


        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="!loading && groupArr?.length === 0">
              No se encontró información
            </td>
          </tr>
          <ng-container class="" *ngFor="let listaDev of groupArr">
            <tr class="grey lighten-3">
              <td colspan="2" style="font-weight: bold;"><b>{{listaDev.codigoFamilia}}</b></td>
              <td colspan="2"><b></b></td>
              <td><b></b></td>
            </tr>
            <tr *ngFor="let list of listaDev.groupItem">
              <td>{{list.sku}}</td>
              <td>{{list.descripcion}}</td>
              <td>{{list.formato}}</td>
              <td class="text-right">{{list.bultos}}</td>
              <td class="text-right">{{list.unidades}}</td>
            </tr>
          </ng-container>


        </tbody>

        <!-- TOTALES -->
        <tbody class="blue lighten-5" *ngIf="listaRecorridosDev.length > 0">
          <tr>
            <td class="text-right" colspan="3"><strong>Totales</strong></td>
            <td class="text-right"><strong>{{totalCajas}}</strong></td>
            <td class="text-right"><strong>{{totalUnidades}}</strong></td>
          </tr>
        </tbody>
        <!-- <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
        *ngIf="listaRecorridosDev?.length > 0"></app-pagination> -->
      </table>
    </div>



  </div>
</div>







<div class="card mb-2 wow" *ngIf="this.processing && listaRecorridosDev.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect (click)="exportarExcel()" class="btn btn-sm">
      Excel
    </button>
    <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="downloadExcelPdf('PDF')">
      Imprimir
    </button>
  </div>
</div>